import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import tiktok from "../../Assets/Projects/tiktok.png";
import petshop from "../../Assets/Projects/petshop.png";
import ytlist from "../../Assets/Projects/codeytlist.png";
import coronoing from "../../Assets/Projects/coronoing.png";
import qrcode from "../../Assets/Projects/qrcode.png";
import Twtshort from "../../Assets/Projects/blog.png";
import volumebooster from "../../Assets/Projects/volumebooster.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
          
            <ProjectCard
              imgPath={coronoing}
              isDemo={true}
              isNone={false}
              title="Coronoing"
              description="Build with Canvas HTML/CSS, JavaScript, Socket.io, and NodeJS, this project features an immersive gameplay experience where players must skillfully avoid harmful viruses while navigating through the bloodstream."
              ghLink="https://github.com/nwucha"
              demoLink="https://coronoing.netlify.app"
            />
          </Col>
      
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={volumebooster}
              isDemo={true}
              isNone={false}
              title="Volume Boost Hub Extension"
              description="Boost the Volume. Powerful All-In-One Sound Enhancement Tools for Chrome Browser. "
              ghLink="https://github.com/nwucha"
             demoLink="https://chromewebstore.google.com/detail/lpchnognaapglnmmcfbgheomlcnhekfk?utm_source=item-share-cb" 
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Twtshort}
              isDemo={true}
              isNone={false}
              title="React TwtShort"
              description="You can set your message and username, but with a twist: You can update them only if your username is shorter than the previous user! Just sign in with Twitter Auth. Connected with Firebase and a little Tailwind"
              ghLink="https://github.com/nwucha"
              demoLink="https://twtshort.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ytlist}
              isDemo={true}
              isNone={false}
              title="YouTube List View"
              description="The YouTube List View Extension ensures that your subscriptions and channel videos are always displayed in List View Mode."
              ghLink="https://github.com/nwucha"
              demoLink="https://chrome.google.com/webstore/detail/youtube-list-view-mode/gefbgfmdacpikggkopbjdjlpfcmgmkop"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tiktok}
              isDemo={false}
              isNone={true}
              title="TikTok LIVE Viewers Race"
              description="More likes you get, the quicker you reach the goal. Gifts turn into goalkeepers. Emojis in the live chat stick to your profile picture. Admin panel to change terrain and ban users with NodeJS Express, Socket.io and Tiktok-Live-Connector"
              ghLink="https://github.com/nwucha"
              demoLink="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={qrcode}
              isDemo={true}
              isNone={false}
              title="QRCode React WiFi Generator"
              description="Generate a QRcode for your WiFi connection using package qrcode "
              ghLink="https://github.com/nwucha"
              demoLink="https://wqrcode.netlify.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={petshop}
              isDemo={false}
              isNone={true}
              title="Pet Shop Store"
              description="Pet shop that I made for one of my clients. "
              ghLink="https://github.com/nwucha"
             demoLink="#" 
            />
          </Col>
    
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
